import Footer from "@/components/layout/footer";
import Header from "@/components/layout/header";
import { Toaster } from "react-hot-toast";

const HorizontalLayout = (props: any) => {
  return (
    <div className="flex min-h-screen w-full flex-col">
      <Header />
      <main className="flex min-h-[calc(100vh_-_theme(spacing.36))] flex-1 flex-col bg-muted/40">
        {props.children}
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          className: "",
          duration: 5000,
          style: {
            background: "#363636",
            color: "#fff",
          },
          success: {
            duration: 3000,
          },
        }}
      />
    </div>
  );
};

export default HorizontalLayout;
